import useSWR from "swr";
import { listFilterTypes } from "./service";
import { UseFilterTypesModel } from "./types";

const useFilterTypes = (): UseFilterTypesModel => {
  const { data, error, isLoading, mutate } = useSWR(
    `/scoring/mda/filters/types`,
    () => listFilterTypes(),
  );

  return {
    data,
    isLoading,
    error,
    mutate,
  };
};

export default useFilterTypes;
